import { Toast, Dialog } from 'vant'
import store from '@/store'
import router from '@/router'

export default {
	priceFilter(val) {
		const numberVal = Number(val)
		if (Number.isNaN(numberVal)) return '0.00'
		return numberVal.toFixed(2)
	},
	// 登录失效时的处理
	loginFailure(cb = null) {
		Dialog.alert({
			title: '欢迎使用柏慧康医检',
			message: '请使用手机号码完成登录',
			confirmButtonText: '登录账号'
		}).then(async () => {
			cb && cb()
			store.commit('router/SET_REDIRECT', router.currentRoute.fullPath)
			await router.replace({
				path: '/account/login',
				query: {
					type: 'again'
				}
			})
		})
	},
	loading(message = '加载中...') {
		Toast.loading({
			message,
			forbidClick: true,
			loadingType: 'spinner',
			duration: 0
		})
	},
	// 给data 赋值
	dataAssign(params, data, cb) {
		Object.keys(params).forEach(item =>
			cb(item, data[item] || params[item])
		)
	},
	isArray(val) {
		if (!Array.isArray) {
			return Object.prototype.toString.call(val) === '[object Array]'
		}
		return Array.isArray(val)
	},
	isNumber(val) {
		if (typeof val === 'number' && !Number.isNaN(val)) {
			return true
		}
		return false
	},
	isString(val) {
		return typeof val === 'string'
	},
	/**
	 * 截取字符串
	 * @param { string } val 要处理的字符串
	 * @param { string | index | array } reg 索引或关键字
	 * @param { boolean } isLast 是否从后检索
	 * @returns {string|null}
	 */
	substrLastIndex(val, reg, isLast = false) {
		if (!this.isString(val)) return null
		if (this.isArray(reg)) return val.substring(reg[0], reg[1])
		if (this.isNumber(reg)) return val.substring(0, reg)
		if (isLast) return val.substring(0, val.lastIndexOf(reg))
		return val.substring(0, val.indexOf(reg))
	},
	// 日期格式化 带上年月日
	vantDateTimePickerFormatter(type, val) {
		switch (type) {
			case 'year':
				return val + '年'
			case 'month':
				return val + '月'
			case 'day':
				return val + '日'
			case 'hour':
				return val + '时'
			case 'minute':
				return val + '分'
			default:
				return val
		}
	},
	// 服务包服务项的有效期计算
	serviceItemValidity(lifespan) {
		if (lifespan) {
			const m = Math.floor(lifespan / 30)
			const d = lifespan - m * 30
			if (m <= 0) {
				return `${lifespan}天`
			}
			if (d > 0) {
				return `${m}个月零${d}天`
			}
			return `${m}个月`
		}
		return ``
	},
	clearDialog() {
		if (document.querySelector('.van-dialog')) {
			document.querySelector('.van-dialog').remove()
		}
	},
	openPDF(pdf) {
		window.location.href = pdf
	},
	windowClose() {
		setTimeout(function () {
			//这个可以关闭安卓系统的手机
			document.addEventListener(
				'WeixinJSBridgeReady',
				function () {
					window.WeixinJSBridge.call('closeWindow')
				},
				false
			)
			//这个可以关闭ios系统的手机
			window.WeixinJSBridge.call('closeWindow')
		}, 300)
	}
}
